import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */
import DefaultLayout from "D:/work/BC_Supermarket/bc-supermarket-docs-docz/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1 {...{
      "id": "social-proof--marketing-features"
    }}>{`Social Proof & Marketing Features`}</h1>
<p>{`From theme version 7.3.0, Supermarket ships with a suite of social-proof and marketing popups: PDP urgency widget, cart-goal progress bar, recent-sales notifications, promotional popup, and exit-intent popup. All features are configured through a single `}<inlineCode parentName="p">{`window.supermarketThemeSettings`}</inlineCode>{` object injected via BigCommerce `}<strong parentName="p">{`Script Manager`}</strong>{`, so merchants can tune behavior without touching theme files.`}</p>
<h2 {...{
      "id": "overview"
    }}>{`Overview`}</h2>
<table>
<thead parentName="table">
<tr parentName="thead">
<th parentName="tr" {...{
            "align": null
          }}>{`Feature`}</th>
<th parentName="tr" {...{
            "align": null
          }}>{`Default state`}</th>
<th parentName="tr" {...{
            "align": null
          }}>{`Enable method`}</th>
</tr>
</thead>
<tbody parentName="table">
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}>{`PDP Urgency Widget`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Enabled`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`urgency.enabled: true`}</inlineCode>{` (default)`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}>{`Cart Goal Bar`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Disabled`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`cartGoal.enabled: true`}</inlineCode>{` + configure `}<inlineCode parentName="td">{`items`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}>{`Recent Sales Popup`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Enabled (safe defaults)`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`recentSales.enabled: true`}</inlineCode>{` (default)`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}>{`Promotional Popup`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Disabled`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`promo.enabled: true`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}>{`Exit-Intent Popup`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Disabled`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`exit.enabled: true`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}>{`Newsletter Popup`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Configured via Theme Editor`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`nl_popup_show`}</inlineCode>{` theme setting (unchanged)`}</td>
</tr>
</tbody>
</table>
<h2 {...{
      "id": "configuration-via-script-manager"
    }}>{`Configuration via Script Manager`}</h2>
<p>{`All settings live in one JavaScript snippet injected through the BigCommerce Script Manager. No schema.json or theme-editor changes are required.`}</p>
<ol>
<li parentName="ol">{`Log in to `}<strong parentName="li">{`BigCommerce Admin`}</strong>{`.`}</li>
<li parentName="ol">{`Go to `}<strong parentName="li">{`Storefront`}</strong>{` > `}<strong parentName="li">{`Script Manager`}</strong>{`.`}</li>
<li parentName="ol">{`Click `}<strong parentName="li">{`Create a Script`}</strong>{`.`}</li>
<li parentName="ol">{`Set the fields:`}<ul parentName="li">
<li parentName="ul"><strong parentName="li">{`Name of Script`}</strong>{`: `}<inlineCode parentName="li">{`Papathemes Social Proof`}</inlineCode></li>
<li parentName="ul"><strong parentName="li">{`Placement`}</strong>{`: `}<inlineCode parentName="li">{`Footer`}</inlineCode></li>
<li parentName="ul"><strong parentName="li">{`Location on page`}</strong>{`: `}<inlineCode parentName="li">{`All pages`}</inlineCode></li>
<li parentName="ul"><strong parentName="li">{`Select script category`}</strong>{`: `}<inlineCode parentName="li">{`Essential`}</inlineCode></li>
<li parentName="ul"><strong parentName="li">{`Script type`}</strong>{`: `}<inlineCode parentName="li">{`Script`}</inlineCode></li>
</ul></li>
<li parentName="ol">{`Paste your snippet (see examples below) wrapped in `}<inlineCode parentName="li">{`<script>`}</inlineCode>{` tags.`}</li>
<li parentName="ol">{`Click `}<strong parentName="li">{`Save`}</strong>{`.`}</li>
</ol>
<h2 {...{
      "id": "starter-snippet"
    }}>{`Starter snippet`}</h2>
<p>{`Copy this as a starting point and adjust per feature. Keys you don't include fall back to the theme defaults.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<script>
  window.supermarketThemeSettings = {
    urgency: {
      enabled: true,
      viewCount: { min: 8, max: 42 },
      viewRange: { min: 3, max: 15 },
      lastOrder: { min: 2, max: 60 },
      orderRange: { min: 5, max: 30 },
      refresh: 20000
    },
    cartGoal: {
      enabled: false,
      currency: 'USD',
      hideForGuests: false,
      items: [
        { amount: 50,  icon: 'shipping', label: 'Free Shipping' },
        { amount: 100, icon: 'discount', label: '10% Off' },
        { amount: 150, icon: 'gift',     label: 'Free Gift' }
      ]
    },
    recentSales: {
      enabled: true,
      source: 'best-sellers',
      timing: { delay: 8000, duration: 6000, interval: 20000, maxShows: 3 },
      position: 'bottom-left',
      pages: 'all',
      excludePages: ['/cart.php', '/checkout']
    },
    promo: {
      enabled: false,
      title: 'Special Offer',
      description: 'Get 15% off your first order!',
      coupon: 'WELCOME15',
      buttonText: 'Copy Code',
      delay: 10000,
      freqDays: 7
    },
    exit: {
      enabled: false,
      mode: 'discount',
      title: 'Wait! Before you go...',
      description: 'Here\\'s 10% off to help you decide.',
      coupon: 'STAY10',
      buttonText: 'Copy Code',
      buttonUrl: '',
      mobileDelay: 30000,
      freqDays: 7
    }
  };
</script>
`}</code></pre>
<h3 {...{
      "id": "pdp-urgency-widget"
    }}>{`PDP Urgency Widget`}</h3>
<p>{`Shows live-like social proof on product pages: `}<em parentName="p">{`"12 people are viewing this"`}</em>{` and `}<em parentName="p">{`"Last ordered 8 minutes ago"`}</em>{`. Numbers are deterministic per product + visitor using a hashed PRNG so repeat views look consistent.`}</p>
<p><img alt="PDP Urgency Widget" src={require("../img/socialproof-urgency.png")} /></p>
<table>
<thead parentName="table">
<tr parentName="thead">
<th parentName="tr" {...{
            "align": null
          }}>{`Key`}</th>
<th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
<th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
<th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
</tr>
</thead>
<tbody parentName="table">
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`enabled`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Master switch`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`viewCount`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`{ min, max }`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`{ min: 8, max: 42 }`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Range of the viewer count`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`viewRange`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`{ min, max }`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`{ min: 3, max: 15 }`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`How much the count drifts per refresh`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`lastOrder`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`{ min, max }`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`{ min: 2, max: 60 }`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Minutes since last order`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`orderRange`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`{ min, max }`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`{ min: 5, max: 30 }`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`How much the last-order value drifts per refresh`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`refresh`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`number (ms)`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`20000`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Interval at which numbers re-roll`}</td>
</tr>
</tbody>
</table>
<p>{`Disable the widget:`}</p>
<pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<script>
  window.supermarketThemeSettings = {
    urgency: { enabled: false }
  };
</script>
`}</code></pre>
<h3 {...{
      "id": "cart-goal-bar"
    }}>{`Cart Goal Bar`}</h3>
<p><img alt="Cart Goal Bar" src={require("../img/socialproof-cart-goal-bar.png")} /></p>
<p>{`A progress bar on the cart / mini-cart that gamifies reaching checkout thresholds (free shipping, percentage discount, free gift, etc.). Thresholds are `}<strong parentName="p">{`display-only`}</strong>{` — create an actual BigCommerce promotion that matches each milestone so customers actually receive the reward.`}</p>
<table>
<thead parentName="table">
<tr parentName="thead">
<th parentName="tr" {...{
            "align": null
          }}>{`Key`}</th>
<th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
<th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
<th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
</tr>
</thead>
<tbody parentName="table">
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`enabled`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Master switch`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`items`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`array of `}<inlineCode parentName="td">{`{ amount, icon, label }`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`[]`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Ordered list of milestones`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`items[].amount`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`—`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Subtotal threshold (in store currency)`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`items[].icon`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`check`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`One of: `}<inlineCode parentName="td">{`shipping`}</inlineCode>{`, `}<inlineCode parentName="td">{`discount`}</inlineCode>{`, `}<inlineCode parentName="td">{`gift`}</inlineCode>{`, `}<inlineCode parentName="td">{`check`}</inlineCode>{`, `}<inlineCode parentName="td">{`bag`}</inlineCode>{`, `}<inlineCode parentName="td">{`star`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`items[].label`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`—`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Text shown next to the icon`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`currency`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`store default`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`ISO currency code used for formatting`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`hideForGuests`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`If `}<inlineCode parentName="td">{`true`}</inlineCode>{`, bar only shows for logged-in customers`}</td>
</tr>
</tbody>
</table>
<p><strong parentName="p">{`Example — 3-milestone ladder:`}</strong></p>
<pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<script>
  window.supermarketThemeSettings = {
    cartGoal: {
      enabled: true,
      currency: 'USD',
      items: [
        { amount: 50,  icon: 'shipping', label: 'Free Shipping' },
        { amount: 100, icon: 'discount', label: '10% Off' },
        { amount: 150, icon: 'gift',     label: 'Free Gift' }
      ]
    }
  };
</script>
`}</code></pre>
<p><strong parentName="p">{`Example — single milestone (free shipping only):`}</strong></p>
<pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<script>
  window.supermarketThemeSettings = {
    cartGoal: {
      enabled: true,
      items: [
        { amount: 75, icon: 'shipping', label: 'Free Shipping' }
      ]
    }
  };
</script>
`}</code></pre>
<blockquote>
<p parentName="blockquote"><strong parentName="p">{`Important`}</strong>{`: Each `}<inlineCode parentName="p">{`amount`}</inlineCode>{` must correspond to a real BigCommerce promotion (`}<strong parentName="p">{`Marketing`}</strong>{` > `}<strong parentName="p">{`Promotions`}</strong>{`). The bar only reflects progress visually — it does not create discounts.`}</p>
</blockquote>
<h3 {...{
      "id": "recent-sales-popup"
    }}>{`Recent Sales Popup`}</h3>
<p><img alt="Recent Sales Popup" src={require("../img/socialproof-recent-sales.png")} /></p>
<p>{`A small popup in the corner of the page saying `}<em parentName="p">{`"Someone in Chicago just bought `}{`[Product Name]`}{` — 3 minutes ago"`}</em>{`. Products come from BigCommerce via GraphQL Storefront API.`}</p>
<table>
<thead parentName="table">
<tr parentName="thead">
<th parentName="tr" {...{
            "align": null
          }}>{`Key`}</th>
<th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
<th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
<th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
</tr>
</thead>
<tbody parentName="table">
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`enabled`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Master switch`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`source`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`best-sellers`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`One of: `}<inlineCode parentName="td">{`best-sellers`}</inlineCode>{`, `}<inlineCode parentName="td">{`new`}</inlineCode>{`, `}<inlineCode parentName="td">{`featured`}</inlineCode>{`, `}<inlineCode parentName="td">{`manual`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`items`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`array`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`[]`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Required when `}<inlineCode parentName="td">{`source: 'manual'`}</inlineCode>{` — see below`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`items[].productId`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`—`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`BigCommerce product ID (OR use `}<inlineCode parentName="td">{`sku`}</inlineCode>{`)`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`items[].sku`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`—`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Product SKU (OR use `}<inlineCode parentName="td">{`productId`}</inlineCode>{`)`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`items[].location`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`—`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`e.g. `}<inlineCode parentName="td">{`"Chicago, IL"`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`items[].timeAgo`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`—`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`e.g. `}<inlineCode parentName="td">{`"3 minutes ago"`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`timing.delay`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`number (ms)`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`8000`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Delay before first popup`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`timing.duration`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`number (ms)`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`6000`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`How long each popup stays visible`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`timing.interval`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`number (ms)`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`20000`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Gap between popups`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`timing.maxShows`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`3`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Max popups per session`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`position`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`bottom-left`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`bottom-left`}</inlineCode>{` or `}<inlineCode parentName="td">{`bottom-right`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`pages`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`all`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`all`}</inlineCode>{`, `}<inlineCode parentName="td">{`home`}</inlineCode>{`, `}<inlineCode parentName="td">{`product`}</inlineCode>{`, `}<inlineCode parentName="td">{`category`}</inlineCode>{`, or `}<inlineCode parentName="td">{`none`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`excludePages`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`array of strings`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`[]`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`URL paths to skip (e.g. `}<inlineCode parentName="td">{`['/cart.php', '/checkout']`}</inlineCode>{`)`}</td>
</tr>
</tbody>
</table>
<p><strong parentName="p">{`Example — manual product list:`}</strong></p>
<pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<script>
  window.supermarketThemeSettings = {
    recentSales: {
      enabled: true,
      source: 'manual',
      items: [
        { sku: 'SKU-001', location: 'New York, NY',    timeAgo: '2 minutes ago' },
        { sku: 'SKU-002', location: 'Los Angeles, CA', timeAgo: '5 minutes ago' },
        { sku: 'SKU-003', location: 'Chicago, IL',     timeAgo: '12 minutes ago' }
      ],
      timing: { delay: 5000, duration: 6000, interval: 15000, maxShows: 5 },
      position: 'bottom-right'
    }
  };
</script>
`}</code></pre>
<p><strong parentName="p">{`Troubleshooting — popup not showing?`}</strong></p>
<ul>
<li parentName="ul">{`Verify the GraphQL Storefront API token is available — the theme emits a console warning if the token is missing.`}</li>
<li parentName="ul">{`Check browser ad-blockers / privacy extensions — some strip the popup container.`}</li>
<li parentName="ul">{`Confirm the current URL isn't in `}<inlineCode parentName="li">{`excludePages`}</inlineCode>{` and that `}<inlineCode parentName="li">{`pages`}</inlineCode>{` includes the current page type.`}</li>
<li parentName="ul">{`Clear `}<inlineCode parentName="li">{`sessionStorage`}</inlineCode>{` — dismissing the popup sets a `}<inlineCode parentName="li">{`papathemes_socialproof_recentSales_dismissed`}</inlineCode>{` key that suppresses it for the remainder of the session.`}</li>
<li parentName="ul">{`Open DevTools and check for `}<inlineCode parentName="li">{`[papathemes-socialproof]`}</inlineCode>{` warnings.`}</li>
</ul>
<h3 {...{
      "id": "promotional-popup"
    }}>{`Promotional Popup`}</h3>
<p><img alt="Promotional Popup" src={require("../img/socialproof-promo-popup.png")} /></p>
<p>{`A centered modal advertising a coupon or campaign with click-to-copy of the coupon code.`}</p>
<table>
<thead parentName="table">
<tr parentName="thead">
<th parentName="tr" {...{
            "align": null
          }}>{`Key`}</th>
<th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
<th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
<th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
</tr>
</thead>
<tbody parentName="table">
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`enabled`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Master switch`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`title`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`'Special Offer'`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Heading text`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`description`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`''`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Body text (plain text or basic HTML)`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`coupon`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`''`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Coupon code rendered as a click-to-copy chip`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`buttonText`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`'Copy Code'`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`CTA label`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`buttonUrl`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`''`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Optional URL the button links to instead of copying`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`delay`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`number (ms)`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`10000`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Delay before popup appears`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`freqDays`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`7`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Dismissal cool-down period`}</td>
</tr>
</tbody>
</table>
<p><strong parentName="p">{`Example:`}</strong></p>
<pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<script>
  window.supermarketThemeSettings = {
    promo: {
      enabled: true,
      title: 'Spring Sale - 20% Off',
      description: 'Use the code below at checkout for 20% off sitewide.',
      coupon: 'SPRING20',
      buttonText: 'Copy Code',
      delay: 8000,
      freqDays: 14
    }
  };
</script>
`}</code></pre>
<h3 {...{
      "id": "exit-intent-popup"
    }}>{`Exit-Intent Popup`}</h3>
<p><img alt="Exit-Intent Popup" src={require("../img/socialproof-exit-popup.png")} /></p>
<p>{`Appears when the user is about to leave the page. On `}<strong parentName="p">{`desktop`}</strong>{`, the trigger is the mouse moving out the top of the viewport. On `}<strong parentName="p">{`mobile`}</strong>{`, since there is no mouse-leave event, the trigger is `}<inlineCode parentName="p">{`mobileDelay`}</inlineCode>{` ms of user inactivity (no scroll / no tap).`}</p>
<table>
<thead parentName="table">
<tr parentName="thead">
<th parentName="tr" {...{
            "align": null
          }}>{`Key`}</th>
<th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
<th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
<th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
</tr>
</thead>
<tbody parentName="table">
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`enabled`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Master switch`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`mode`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`'discount'`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`'discount'`}</inlineCode>{`, `}<inlineCode parentName="td">{`'newsletter'`}</inlineCode>{`, or `}<inlineCode parentName="td">{`'custom'`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`title`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`'Wait! Before you go...'`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Heading text`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`description`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`''`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Body text`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`coupon`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`''`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Shown when `}<inlineCode parentName="td">{`mode: 'discount'`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`buttonText`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`'Copy Code'`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`CTA label`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`buttonUrl`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`''`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`URL the button links to (overrides copy behavior)`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`mobileDelay`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`number (ms)`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`30000`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Mobile inactivity threshold`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`freqDays`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
<td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`7`}</inlineCode></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Dismissal cool-down period`}</td>
</tr>
</tbody>
</table>
<p><strong parentName="p">{`Example:`}</strong></p>
<pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<script>
  window.supermarketThemeSettings = {
    exit: {
      enabled: true,
      mode: 'discount',
      title: 'Wait! Here\\'s 10% off',
      description: 'Don\\'t leave empty handed — use this code at checkout.',
      coupon: 'STAY10',
      buttonText: 'Copy Code',
      mobileDelay: 30000,
      freqDays: 7
    }
  };
</script>
`}</code></pre>
<h3 {...{
      "id": "newsletter-popup"
    }}>{`Newsletter Popup`}</h3>
<p>{`The existing Newsletter popup is `}<strong parentName="p">{`unchanged`}</strong>{` — all theme-editor settings (`}<inlineCode parentName="p">{`nl_popup_show`}</inlineCode>{`, `}<inlineCode parentName="p">{`nl_popup_start`}</inlineCode>{`, `}<inlineCode parentName="p">{`nl_popup_hide`}</inlineCode>{`) and the `}<inlineCode parentName="p">{`NL_POPUP_HIDE`}</inlineCode>{` cookie continue to work as before.`}</p>
<p>{`From theme `}<strong parentName="p">{`7.3.0`}</strong>{` onward, the newsletter popup is coordinated with the new social-proof popups through a priority queue so only one popup is shown at a time. The queue order (highest priority first) is: `}<strong parentName="p">{`Exit Intent`}</strong>{` > `}<strong parentName="p">{`Promo`}</strong>{` > `}<strong parentName="p">{`Newsletter`}</strong>{` > `}<strong parentName="p">{`Recent Sales`}</strong>{`. No configuration is required to enable this — it kicks in automatically when the new popups are active.`}</p>
<h2 {...{
      "id": "disable-all"
    }}>{`Disable All`}</h2>
<p>{`If you want to opt out of every new popup and keep only the legacy behavior:`}</p>
<pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<script>
  window.supermarketThemeSettings = {
    urgency:     { enabled: false },
    cartGoal:    { enabled: false },
    recentSales: { enabled: false },
    promo:       { enabled: false },
    exit:        { enabled: false }
  };
</script>
`}</code></pre>
<h2 {...{
      "id": "debugging"
    }}>{`Debugging`}</h2>
<ul>
<li parentName="ul">{`Open DevTools console and run `}<inlineCode parentName="li">{`console.log(window.supermarketThemeSettings)`}</inlineCode>{` to confirm your snippet loaded and merged correctly.`}</li>
<li parentName="ul">{`Check the console for warnings prefixed with `}<inlineCode parentName="li">{`[papathemes-socialproof]`}</inlineCode>{` — they indicate missing tokens, invalid config, or GraphQL errors.`}</li>
<li parentName="ul">{`Open the `}<strong parentName="li">{`Network`}</strong>{` tab and filter for `}<inlineCode parentName="li">{`graphql`}</inlineCode>{` to diagnose failed Storefront API calls (typical for `}<inlineCode parentName="li">{`recentSales`}</inlineCode>{` with `}<inlineCode parentName="li">{`source: 'best-sellers' | 'new' | 'featured'`}</inlineCode>{`).`}</li>
<li parentName="ul">{`Inspect `}<strong parentName="li">{`sessionStorage`}</strong>{` and `}<strong parentName="li">{`localStorage`}</strong>{` under Application in DevTools — look for `}<inlineCode parentName="li">{`papathemes_socialproof_*`}</inlineCode>{` keys. Delete them to reset dismiss state while testing.`}</li>
<li parentName="ul">{`Confirm the bundle loaded: `}<inlineCode parentName="li">{`window.__papathemesSocialproofActive === true`}</inlineCode>{` in the console. If it is `}<inlineCode parentName="li">{`undefined`}</inlineCode>{`, the theme-bundle has not initialized the module (most likely a cached legacy bundle — hard-reload the page).`}</li>
</ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      